// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";
import useUserProfile from "../hooks/useUserProfile"; // ← add this

export default function ProtectedRoute({ children, requireVerified = false, redirectToIfUnauthed = "/" }) {
  const { user, loading } = useAuth();
  const { profile, loading: profileLoading } = useUserProfile(); // ← read admin override
  const loc = useLocation();

  if (loading || profileLoading) return null;

  if (!user) return <Navigate to={redirectToIfUnauthed} replace state={{ from: loc }} />;

  if (requireVerified) {
    // Check if user is verified by email OR phone OR admin
    // Also allow access to profile page for new phone users (they need to complete setup)
    const isPhoneUser = user.phoneNumber && !user.email;
    const isProfilePage = loc.pathname === '/profile';
    
    // Allow phone users to access profile page for setup
    if (isPhoneUser && isProfilePage) {
      return children;
    }
    
    // For other verified routes, check verification
    const ok = user.emailVerified === true || user.phoneNumber || profile?.verifiedByAdmin === true;
    if (!ok) return <Navigate to="/verify" replace />;
  }

  return children;
}
